
import React, { useContext, useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { ContextType, verificationContext } from '../context/VerificationContext'
import { Typography, IconButton, Divider, List, ListItem, ListItemText } from '@mui/material'
import { allergytableDataType } from '../Types/TableType'
import EditNoteIcon from '@mui/icons-material/EditNote';
import ErrorIcon from '@mui/icons-material/Error';
import { getAllergyData } from '../../../EMR/services'
import usePopup from '../../../hooks/usePopup'
import PatientAllergy, { AllergyProvider } from '../../../EMR/components/Allergy'
function AllergyTable() {

  const { searchData } = useContext(verificationContext) as ContextType
  const [tableData, setTableData] = useState<allergytableDataType>({ totalCount: 0, items: [] })
  const [open, setOpen] = useState<boolean>(false)
  const { mutate: getAllergy } = useMutation(getAllergyData, { onSuccess: (data) => { setTableData((prev) => ({ ...prev, items: data.response })) } })
  const { CustomModal } = usePopup()
  useEffect(() => {
    if (searchData?.pmaster?.id) {
      getAllergy(`${searchData?.pmaster?.id}`)
    }
  }, [searchData?.pmaster?.id])
  const closepopUp = () => {
    getAllergy(`${searchData?.pmaster?.id}`)
    setOpen(false)
  }
  return (
    <>
      <CustomModal title='Allergy' open={open} setOpen={setOpen} handleClose={() => { closepopUp() }} >
        <div className='max-h-[70dvh]   p-2 overflow-auto' >
          <AllergyProvider><PatientAllergy /></AllergyProvider>
        </div>
      </CustomModal>
      <div className='flex  justify-between me-5'>
        <Typography className="!ml-2">
          <strong>Allergy</strong>
        </Typography>
        <IconButton edge="end" aria-label="delete" onClick={() => setOpen(true)}>
          <EditNoteIcon color='primary' />
        </IconButton>
      </div>
      <Divider />
     <List>
  {tableData.items?.length > 0 ? (
    tableData.items.map((item) =>
      item?.data?.map((record, subIndex) => {

        const allergyTypeName = record?.allergyType?.allergyTypeName ?? "";
        const allergenName = record?.allergen?.allergenName ?? "";

        const isUnknown = allergyTypeName.toLowerCase() === "unknown";

        return (
          <React.Fragment key={record.id ?? subIndex}>
            <ListItem alignItems="flex-start">
              <ListItemText
                primary={
                  isUnknown
                    ? `(${allergyTypeName})`
                    : `${allergenName} - (${allergyTypeName})`
                }
              />
            </ListItem>
            <Divider />
          </React.Fragment>
        );
      })
    )
  ) : (
    <div className="col-span-12 flex justify-center items-center flex-col gap-2">
      <ErrorIcon color="info" sx={{ fontSize: "2rem" }} />
      No Allergy found
    </div>
  )}
</List>

    </>
  )
}

export default AllergyTable
